(function(){
  function ready(fn){if(document.readyState!='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    var root = document.querySelector('.oa-page');
    if(!root) return;
    var isMobile = window.matchMedia('(max-width: 700px)').matches;

    // STARFIELD
    var sf = document.getElementById('oaStarfield');
    if(sf){
      var starCount = isMobile ? 65 : 130;
      for(var i=0;i<starCount;i++){
        var s = document.createElement('div');
        s.className = 'oa-star';
        if(Math.random()>0.85) s.className += ' lg';
        if(Math.random()>0.9) s.className += ' gold';
        if(Math.random()>0.95) s.className += ' aurora';
        s.style.top = Math.random()*100+'%';
        s.style.left = Math.random()*100+'%';
        s.style.animationDelay = Math.random()*4+'s';
        sf.appendChild(s);
      }
    }

    // DRIFTING PARTICLES
    var pc = document.getElementById('oaParticles');
    if(pc){
      var pCount = isMobile ? 10 : 20;
      for(var j=0;j<pCount;j++){
        var p = document.createElement('div');
        p.className = 'oa-particle';
        if(Math.random()>0.7) p.className += ' lg';
        if(Math.random()>0.7) p.className += ' sm';
        p.style.left = Math.random()*100+'%';
        var dx = (Math.random()-0.5)*200;
        p.style.setProperty('--dx', dx+'px');
        var dur = 16+Math.random()*18;
        var delay = Math.random()*14;
        p.style.animation = 'oa-drift '+dur+'s linear '+delay+'s infinite';
        pc.appendChild(p);
      }
    }

    // SCROLL REVEAL
    if('IntersectionObserver' in window){
      var revealEls = root.querySelectorAll('.oa-reveal');
      var revealObs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            e.target.classList.add('in');
            revealObs.unobserve(e.target);
          }
        });
      },{rootMargin:'0px 0px -10% 0px'});
      revealEls.forEach(function(el){revealObs.observe(el);});
    } else {
      root.querySelectorAll('.oa-reveal').forEach(function(el){el.classList.add('in');});
    }

    // TRANSFORMATION CYCLE
    var txImgs = root.querySelectorAll('.oa-tx-img');
    var txTag = document.getElementById('oaTxTag');
    if(txImgs.length > 1 && txTag){
      var txIdx = 0;
      var first = root.querySelector('.oa-tx-img.active') || txImgs[0];
      if(first && first.dataset.tag){ txTag.textContent = first.dataset.tag; }
      setInterval(function(){
        txImgs[txIdx].classList.remove('active');
        txIdx = (txIdx + 1) % txImgs.length;
        txImgs[txIdx].classList.add('active');
        if(txImgs[txIdx].dataset.tag){
          txTag.style.opacity = '0';
          setTimeout(function(){
            txTag.textContent = txImgs[txIdx].dataset.tag;
            txTag.style.transition = 'opacity 0.4s';
            txTag.style.opacity = '1';
          },300);
        }
      },2400);
    }

    // LIVE SALES TICKER
    var tcont = document.getElementById('oaTickerCards');
    if(tcont){
      var salesData = tcont.dataset.sales || '';
      var prodData = tcont.dataset.products || '';
      var sales = salesData.split('|').filter(Boolean).map(function(s){var p=s.split('~');return{n:p[0]||'Friend',c:p[1]||'',i:p[2]||(p[0]||'').substr(0,2).toUpperCase()};});
      var products = prodData.split('|').filter(Boolean);
      if(sales.length===0) sales = [{n:'Jessica',c:'Austin, TX',i:'JE'},{n:'Tyler',c:'Chicago, IL',i:'TY'},{n:'Ashley',c:'Nashville, TN',i:'AS'},{n:'Jordan',c:'Denver, CO',i:'JO'},{n:'Megan',c:'Portland, OR',i:'ME'},{n:'Chris',c:'Seattle, WA',i:'CH'},{n:'Sarah',c:'San Diego, CA',i:'SA'},{n:'Mike',c:'Brooklyn, NY',i:'MI'},{n:'Lauren',c:'Boston, MA',i:'LA'},{n:'David',c:'Minneapolis, MN',i:'DA'},{n:'Emma',c:'Phoenix, AZ',i:'EM'},{n:'Ryan',c:'Atlanta, GA',i:'RY'}];
      if(products.length===0) products = ['Custom Photo Mug','Custom Photo Hoodie','Custom Wall Art','Custom Photo Journal','Pet Portrait Print','Custom Tote Bag','Custom Pillow','Custom Canvas','Custom Phone Case'];
      var shuf = sales.slice().sort(function(){return Math.random()-0.5;});
      var si = 0;
      function nxt(){return shuf[si++ % shuf.length];}
      function tickerHTML(s,p,t){return '<div class="oa-t-av">'+s.i+'</div><div class="oa-t-body"><div class="oa-t-name">'+s.n+' · '+s.c+'</div><div class="oa-t-prod">bought '+p+'</div></div><div class="oa-t-time">'+t+'</div>';}
      function fillSlot(el){
        var s = nxt();
        var p = products[Math.floor(Math.random()*products.length)];
        var h = Math.floor(Math.random()*18)+1;
        var t = h===1?'1 hr ago':h+' hrs ago';
        el.style.opacity = '0';
        setTimeout(function(){el.innerHTML = tickerHTML(s,p,t);el.style.transition='opacity 0.4s';el.style.opacity='1';},400);
      }
      var slots = [];
      for(var k=0;k<3;k++){
        var c = document.createElement('div');
        c.className = 'oa-ticker-card';
        var s0 = nxt();
        var p0 = products[Math.floor(Math.random()*products.length)];
        var h0 = Math.floor(Math.random()*18)+1;
        var t0 = h0===1?'1 hr ago':h0+' hrs ago';
        c.innerHTML = tickerHTML(s0,p0,t0);
        tcont.appendChild(c);
        slots.push(c);
      }
      setInterval(function(){fillSlot(slots[0]);},7000);
      setInterval(function(){fillSlot(slots[1]);},10500);
      setInterval(function(){fillSlot(slots[2]);},14000);
    }

    // TESTIMONIALS DUPLICATION (for infinite scroll)
    var testTrack = document.getElementById('oaTestTrack');
    if(testTrack){
      var origHTML = testTrack.innerHTML;
      testTrack.innerHTML = origHTML + origHTML;
    }

    // JOURNAL CAROUSEL ARROWS
    var carousel = document.getElementById('oaJCarousel');
    var prev = document.getElementById('oaJPrev');
    var next = document.getElementById('oaJNext');
    if(carousel && prev && next){
      function scrollAmt(){
        var card = carousel.querySelector('.oa-j-card');
        if(!card) return 320;
        var gap = parseFloat(getComputedStyle(carousel).gap) || 20;
        return card.offsetWidth + gap;
      }
      function updateArrows(){
        prev.disabled = carousel.scrollLeft <= 4;
        next.disabled = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 4;
      }
      prev.addEventListener('click',function(){carousel.scrollBy({left:-scrollAmt(),behavior:'smooth'});});
      next.addEventListener('click',function(){carousel.scrollBy({left:scrollAmt(),behavior:'smooth'});});
      carousel.addEventListener('scroll',updateArrows);
      updateArrows();
    }

    // THE QUESTION - words appear on scroll
    var qSection = document.getElementById('oaQuestion');
    if(qSection && 'IntersectionObserver' in window){
      var qWords = qSection.querySelectorAll('.oa-q-word');
      var qAnswer = qSection.querySelector('.oa-q-answer');
      var qObs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            qWords.forEach(function(w,i){
              setTimeout(function(){w.classList.add('in');},i*220);
            });
            if(qAnswer){
              setTimeout(function(){qAnswer.classList.add('in');},qWords.length*220+200);
            }
            qObs.unobserve(e.target);
          }
        });
      },{threshold:0.3});
      qObs.observe(qSection);
    } else if(qSection){
      qSection.querySelectorAll('.oa-q-word').forEach(function(w){w.classList.add('in');});
      var a = qSection.querySelector('.oa-q-answer'); if(a) a.classList.add('in');
    }
  });
})();
